export const extractFlavors = (flavors, flavorOptions) =>
  flavors
    .map((id) => {
      const flavor = flavorOptions.find((f) => f._id === id);
      return flavor ? flavor.name : "Unknown Flavor";
    })
    .join(", ");

export const getIcingName = (icingId, icingOptions) => {
  const icing = icingOptions.find((i) => i._id === icingId);
  return icing ? icing.name : "Unknown Icing";
};

export const extractSizes = (sizeIds, sizeOptions) => {
  const result = sizeIds
    .map((size) => {
      const matched = sizeOptions.find((s) => s._id === size._id);
      return matched;
    })
    .filter(Boolean)
    .map((s) => {
      return s.name;
    })
    .join(", ");

  return result;
};
